import { connect } from 'react-redux'
import * as qs from 'utils/querystring'

import RescheduleConfirm from './RescheduleConfirm'

import {
  getServices,
  getAliadas
} from '@src/redux/modules/entities'
import {
  fetch as fetchService,
  update as updateService,
  isFetching as isFetchingService,
  isUpdating as isUpdatingService
} from '@src/redux/modules/service'
import {
  fetchAliada
} from '@src/redux/modules/aliada'

const getService = (services, serviceId) => services[serviceId]

function getBeforeRescheduleServiceDetails (service, aliadas) {
  const ready = service
  if (ready) {
    const { id, firstName, lastName } = aliadas[service.aliada]
    return {
      aliada: { id, firstName, lastName },
      datetime: service.datetime,
      estimatedHours: service.estimatedHours,
      cost: service.cost
    }
  }
}

function getAfterRescheduleServiceDetails (serviceModifications, aliadas) {
  const aliada = aliadas[serviceModifications.aliadaId]

  const ready = serviceModifications && aliada
  if (ready) {
    const { id, firstName, lastName, serviceCost: cost } = aliada
    const { datetime, estimatedHours } = serviceModifications

    return {
      aliada: { id, firstName, lastName },
      datetime,
      estimatedHours,
      cost
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceId } = ownProps.params
  const services = getServices(state)
  const service = getService(services, serviceId)
  const fetchingService = isFetchingService(state)
  const updatingService = isUpdatingService(state)

  const serviceModifications = qs.parse(ownProps.location.search)

  const aliadas = getAliadas(state)
  const aliada = aliadas[serviceModifications.aliadaId]

  const beforeRescheduleServiceDetails = getBeforeRescheduleServiceDetails(service, aliadas)
  const afterRescheduleServiceDetails = getAfterRescheduleServiceDetails(serviceModifications, aliadas)

  return {
    serviceId: parseInt(serviceId),
    service,
    fetchingService,
    updatingService,
    serviceModifications,
    beforeRescheduleServiceDetails,
    afterRescheduleServiceDetails,
    aliada
  }
}

const mapDispatchToProps = {
  fetchService,
  updateService,
  fetchAliada
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RescheduleConfirm)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/RescheduleConfirm/RescheduleConfirmContainer.js